import Button from "@mui/material/Button";
import { Box } from "@mui/material";
import { Storage } from "@aws-amplify/storage";

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "download";
  const clickHandler = () => {
    setTimeout(() => {
      URL.revokeObjectURL(url);
      a.removeEventListener("click", clickHandler);
    }, 150);
  };
  a.addEventListener("click", clickHandler, false);
  a.click();
  return a;
}

export const handleDownloadText = (enabled, txt, filename) => {
  const blob = new Blob([txt], {
    type: "text/plain",
  });
  if (enabled) downloadBlob(blob, filename);
};

export const handleOpenCSV = (
  enabled,
  csvTxt,
  csvfilename,
  setMessageModalContent
) => {
  if (enabled)
    setMessageModalContent({
      title: csvfilename,
      message: <div />,
      buttons: [
        <Button
          key={0}
          variant="outlined"
          sx={{
            margin: "10px 5px",
            width: "100px",
          }}
          onClick={() => handleDownloadText(enabled, csvTxt, csvfilename)}
        >
          Download
        </Button>,
      ],
    });
};

export const handleOpenTXT = (
  enabled,
  txtTxt,
  txtFilename,
  setMessageModalContent
) => {
  if (enabled)
    setMessageModalContent({
      title: txtFilename,
      message: <Box sx={{ maxWidth: "600px" }}>{txtTxt}</Box>,
      buttons: [
        <Button
          key={0}
          variant="outlined"
          sx={{
            margin: "10px 5px",
            width: "100px",
          }}
          onClick={() => handleDownloadText(enabled, txtTxt, txtFilename)}
        >
          Download
        </Button>,
      ],
    });
};

export const fetchImagesFromS3 = async (folderPath): Promise<string[]> => {
  try {
    // List objects in the specified S3 folder
    const result = await Storage.list(folderPath, {
      level: "public",
      pageSize: 10,
    });

    // Filter out non-image files and get their keys
    const imageKeys = result.results
      .filter((item) => /\.(jpg|jpeg|png|gif)$/i.test(item.key))
      .map((item) => item.key);

    // Function to create an image and resolve with its src
    const getImageSrc = (src): Promise<string | null> => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = src;
        img.onload = () => resolve(img.src); // Resolve with image src
        img.onerror = () => resolve(null); // Handle errors gracefully
      });
    };

    // Fetch URLs and create image objects, resolving with image src
    const imageSrcs = await Promise.all(
      imageKeys.map(async (key) => {
        try {
          // Get the URL for each image
          const url = await Storage.get(key, { level: "public" });
          return getImageSrc(url); // Get image src
        } catch (urlError) {
          console.error(`Error getting URL for image ${key}:`, urlError);
          return null; // Return null if there's an error
        }
      })
    );

    return imageSrcs.filter(Boolean); // Filter out any null values
  } catch (error) {
    console.error("Error fetching images from S3:", error);
    return [];
  }
};

export const getDateAsAFolderName = () => {
  const formatTwoDigits = (digit) => ("0" + digit).slice(-2);
  const tempDate = new Date();
  const date = `${tempDate.getFullYear()}${formatTwoDigits(
    tempDate.getMonth() + 1
  )}${formatTwoDigits(tempDate.getDate())}`;
  return date;
};

export const extractSaleYearFromFileName = (fileName) => {
  const pattern = /\d{4}/;
  const match = fileName.match(pattern);

  if (match) {
    const year = parseInt(match[0], 10);
    return year;
  }

  return null;
};

export const extractSaleCodeFromFileName = (fileName) => {
  const pattern = /(?<!\d)\d{2}(?!\d)/;
  const match = fileName.match(pattern);

  if (match) {
    const saleCode = parseInt(match[0], 10);
    return saleCode;
  }

  return null;
};

export const flattenObject = (obj, prefix = "", result = {}) => {
  for (const key in obj) {
    if (typeof obj[key] === "object" && obj[key] !== null) {
      flattenObject(obj[key], `${prefix}${key}.`, result);
    } else {
      result[`${prefix}${key}`] = obj[key];
    }
  }
  return result;
};

export function s3UriToConsoleUrl(s3Uri, region = "ap-southeast-1") {
  if (!s3Uri.startsWith("s3://")) {
    throw new Error("Invalid S3 URI");
  }

  const parts = s3Uri.replace("s3://", "").split("/");
  const bucket = parts.shift();
  const key = parts.join("/");
  let url = `https://${region}.console.aws.amazon.com/s3/buckets/${bucket}?region=${region}&prefix=${encodeURIComponent(
    key
  )}`;
  if (!url.endsWith("/")) {
    url += "/";
  }

  return url;
}
